import CNC from '../Resources/Logo/cnc.svg';
import Conventional from '../Resources/Logo/Conventional.svg';
import Electrical from '../Resources/Logo/electrical.svg';
import Mold from '../Resources/Logo/mold.svg';
import Sheet from '../Resources/Logo/Sheet Metal.svg';
import Welding from '../Resources/Logo/Laser2.svg';
import GearBox from '../Resources/Logo/Gear.svg';


export const departments = [
    {
      name: "CNC",
      description: "High-precision CNC machining solutions for all your manufacturing needs",
      icon: CNC,
      path: "/cnc" 
    },

    {
      name: "التحكم الرقمي بالكمبيوتر",
      description: "حلول التصنيع باستخدام الحاسب الآلي عالية الدقة لجميع احتياجات التصنيع الخاصة بك",
      icon: CNC,
      path: "/cnc" 
    },

    {
      name: "General Machining",
      description: "Comprehensive machining services including gears, shafts, welding, and custom modifications.",
      icon: Conventional,
      path: "/GenralMachning" 
    },


    {
      name: "خراطة عامة",
      description: "خدمات خراطة شاملة تشمل التروس والعمدان واللحام والتعديلات المخصصة",
      icon: Conventional,
      path: "/GenralMachning" 
    },




    {
      name: "Electrical",
      description: "Advanced electrical machining for intricate and accurate parts",
      icon: Electrical,
      path: "/electrical"
    },


    {
      name: "كهربائي",
      description: "تصنيع كهربائي متقدم للأجزاء المعقدة والدقيقة",
      icon: Electrical,
      path: "/electrical"
    },





    {
      name: "Mold & Presses",
      description: "Expert Mold & Die solutions for high-quality, custom manufacturing",
      icon: Mold,
      path: "/mold" 
    },


    {
      name: "قوالب و مكابس",
      description: "حلول متخصصة للقوالب والنماذج لتصنيع عالي الجودة ومخصص",
      icon: Mold,
      path: "/mold" 
    },



    {
      name: "Sheet Metal",
      description: "Precision sheet metal fabrication for versatile and durable products",
      icon: Sheet,
      path: "/sheetmetal" 
    },


    {
      name: "تشكيل المعادن ",
      description: "تصنيع صفائح معدنية دقيقة لمنتجات متعددة الاستخدامات ومتينة",
      icon: Sheet,
      path: "/sheetmetal" 
    },


    {
      name: "Laser Cutting",
      description: "Offers precision laser cutting for various materials with minimal waste",
      icon: Welding,
      path: "/welding" 
    },


    {
      name: "القطع بالليزر",
      description: "تقدم قص الليزر بدقة عالية للعديد من المواد مع الحد الأدنى من الهدر",
      icon: Welding,
      path: "/welding" 
    },



    {
        name: "GearBox",
        description: "High-performance gearbox manufacturing for efficient & reliable power transmission",
        icon: GearBox,
        path: "/gearbox"
    },


    {
      name: "صندوق التروس",
      description: "تصنيع التروس عالية الأداء لنقل الطاقة بكفاءة وموثوقية",
      icon: GearBox,
      path: "/gearbox"
    },




    // Add more departments as needed
  ];
  